import UserController from './userController';

const UserComponent = {
    template: require('./userView.html'),
    controller: UserController
};

export default UserComponent;


// WEBPACK FOOTER //
// ./src/app/pages/user/userComponent.js